import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftShow16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSidebarLeftShow16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h2v10H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m10 0H6v10h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m0-1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM8.81 6.232a.5.5 0 0 1 .707-.707l2.121 2.121.354.354-.354.354-2.12 2.12a.5.5 0 0 1-.708-.706L10.578 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftShow16);
